import React, { useCallback, useRef, useState } from 'react';

type UnregisterAppBarFn = () => void;

interface IContext {
  hideAppBar: boolean;
  registerAppBar: () => UnregisterAppBarFn;
  newTheme: boolean;
}

export const LayoutContext = React.createContext<IContext>({
  hideAppBar: false,
  newTheme: false,
  registerAppBar: () => () => {},
});

type Props = {
  hideAppBar?: boolean;
  children: React.ReactNode;
  newTheme?: boolean;
};

const LayoutContextProvider: React.FC<Props> = (props: Props): JSX.Element => {
  const { children, hideAppBar = false, newTheme = false } = props;

  const [hideAppBarValue, setHideAppBar] = useState(hideAppBar);
  const registeredAppBars = useRef(0);

  const registerAppBar = useCallback((): UnregisterAppBarFn => {
    registeredAppBars.current += 1;
    setHideAppBar(registeredAppBars.current > 1);
    return () => {
      registeredAppBars.current -= 1;
      setHideAppBar(registeredAppBars.current > 1);
    };
  }, []);

  return (
    <LayoutContext.Provider
      value={{
        hideAppBar: hideAppBar || hideAppBarValue,
        registerAppBar,
        newTheme,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutContextProvider;
